export default {
	about: 'About us',
	mission: 'Mission',
	vision: 'Our Message',
	policy: 'What we do?',
	qualityPolicy: 'Our Values'
}